/**
 * 设置组件最小高度为 350px，默认高度为507px
 */
export const judgeHeight = (screenHeight: string | null) => {
  if (!screenHeight) return "507px";
  let h = Number(screenHeight.substring(0, screenHeight.length - 2));
  if (/(.+(?=px$))/.test(screenHeight)) {
    if (h < 358) {
      return "358px";
    } else {
      return screenHeight;
    }
  } else if (/(.+(?=vh$))/.test(screenHeight)) {
    if (h < 54) {
      return "358px";
    } else {
      return screenHeight;
    }
  } else {
    return "507px";
  }
};
export const judgeMapHeight = (screenHeight: string | null) => {
  if (!screenHeight) return "507px";
  let h = Number(screenHeight.substring(0, screenHeight.length - 2));
  if (/(.+(?=px$))/.test(screenHeight)) {
    if (h < 358) {
      return "358px";
    } else {
      return screenHeight;
    }
  } else if (/(.+(?=vh$))/.test(screenHeight)) {
    if (h < 54) {
      return "358px";
    } else {
      return `${h - 15}vh`;
    }
  } else {
    return "507px";
  }
};

/**
 * 设置列表最小高度为 350px，默认高度为507px
 */
export const judgeListPaddingTop = (
  mapHeight: string | null,
  searchBarShow: boolean
) => {
  if (!mapHeight) return "507px";
  if (/(.+(?=vh$))/.test(mapHeight)) {
    // 有搜索框
    if (searchBarShow) {
      return "34.5vh";
    } else {
      return "27vh";
    }
  } else {
    if (searchBarShow) {
      return "230px";
    } else {
      return "200px";
    }
  }
};
/**
 * 设置列表最小高度为 350px，默认高度为507px
 */
export const judgeListWrapHeight = (
  mapHeight: string | null,
  searchBarShow: boolean
) => {
  if (!mapHeight) return "507px";
  if (/(.+(?=vh$))/.test(mapHeight)) {
    // 有搜索框
    if (searchBarShow) {
      return "65.5vh";
    } else {
      return "73vh";
    }
  } else {
    if (searchBarShow) {
      return "230px";
    } else {
      return "200px";
    }
  }
};

/**
 * 设置列表最小高度为 350px，默认高度为507px
 */
export const judgeListHeight = (
  screenHeight: string | null,
  searchBarShow: boolean
) => {
  if (!screenHeight) return "507px";
  let h = Number(screenHeight.substring(0, screenHeight.length - 2));
  if (/(.+(?=px$))/.test(screenHeight)) {
    if (h < 358) {
      return `${358 - 251}px`;
    } else {
      return `${h - 251}px`;
    }
  } else if (/(.+(?=vh$))/.test(screenHeight)) {
    if (h < 54) {
      return `${385 - 251}px`;
    } else {
      // 有搜索框
      if (searchBarShow) {
        return `${h - 44.5}vh`;
      } else {
        return `${h - 36}vh`;
      }
    }
  } else {
    return "507px";
  }
};

declare const AMap: any;
export const location2CityCode = ({ map, lng, lat }) => {
  return new Promise<{ cityCode: string; cityName: string }>(
    (resolve, reject) => {
      map.plugin("AMap.Geocoder", () => {
        const geolocation1 = new AMap.Geocoder({
          city: "" //默认：“全国”
        });
        geolocation1.getAddress([lng, lat], (status, result) => {
          if (status === "complete" && result.regeocode) {
            // console.log('根据经纬度获取地址信息', result);
            let address = result.regeocode && result.regeocode.addressComponent;
            resolve({ cityCode: address.citycode, cityName: address.city });
          } else {
            reject("获取地址信息失败");
          }
        });
      });
    }
  );
};

export const goBack = () => {
  window.history.back();
};

import { simpleShare, openUrl } from "../../utils/common";

const UA = navigator.userAgent || "";
const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
const isIOS = /iPhone|iPad|iPod/i.test(UA); // IOS
let apiDomain = '';
if (window.location.href.indexOf('static.test.xiaopeng.local') !== -1) {
  apiDomain = 'http://static.test.xiaopeng.com';
} else if (window.location.href.indexOf('static.deploy-test.xiaopeng.com') !== -1) {
  apiDomain = 'https://static.deploy-test.xiaopeng.com';
} else if (window.location.href.indexOf('static.xiaopeng.com') !== -1) {
  apiDomain = 'https://static.xiaopeng.com';
}
import Toast from "@xpeng/rc-toast";


export const toShare = () => {
  if (isXPApp) {
    simpleShare(
      { shareTitle: "下一站超快充建站心愿征集，现已开启！", shareDesc: "留下你的建站心愿，或选择成为小鹏充电合作伙伴，超快充首选小鹏充电。", sharePicUrlAccess: "https://s.xiaopeng.com/xp-charge/charge/20231010/next-station_2.png" },
      `${apiDomain}/apps/charge-web/next-station-home.html`
    );
  } else {
    console.log("复制链接");    
    const copyUrl = `下一站超快充建站心愿征集，现已开启！留下你的建站心愿吧！   ${apiDomain}/apps/charge-web/next-station-home.html`;
    
    // 创建元素用于复制
    const ele = document.createElement("input");
    // 设置元素内容
    ele.setAttribute("value", copyUrl);
    // 将元素插入页面进行调用
    document.body.appendChild(ele);
    // 复制内容
    ele.select();
    // 将内容复制到剪贴板
    document.execCommand("copy");
    // 删除创建元素
    document.body.removeChild(ele);
    const toastContainerStyle: React.CSSProperties = {
      position: "absolute",
      top: "45vh"
    };
    const toastStyle: React.CSSProperties = {
      borderRadius: "12pxw",
      fontSize: "16pxw",
      lineHeight: "32pxw",
      padding: "5pxw 10pxw",
      width: "400pxw !important"
    };
    if(isIOS) 
      Toast.show('已复制分享链接到剪贴板',{style: toastStyle, containerStyle: toastContainerStyle})
    else
      Toast.show('已复制分享链接到剪贴板')
  }
};
export const toBePartNer = () => {
  openUrl("https://events.xiaopeng.com/95xu6h.html?ch=04431&ps=event");
};
